import { useInitialLoading } from '../hooks/useInitialLoading';
import React, { useState, useEffect, useCallback } from 'react';
import { getAuthHeaders } from '../utils/authHeaders';
import { API, StateCard } from './InventoryShared';

export default function InventoryOverview() {
  const companyId = localStorage.getItem('selectedCompanyId');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const initialLoading = useInitialLoading(loading);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/companies/${companyId}/inventory/overview`, { headers: getAuthHeaders() });
      if (!res.ok) throw new Error('Failed');
      setData(await res.json());
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [companyId]);

  useEffect(() => { fetchData(); }, [fetchData]);

  if (initialLoading || !data) return <div style={{ padding: 32, textAlign: 'center' }}>Loading...</div>;

  const pa = data.pending_actions || {};

  return (
    <div style={{ padding: '24px 32px', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#1a1a2e' }}>📦 Inventory Overview</h2>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14, marginBottom: 20 }}>
        <StateCard label="Active Products" count={data.product_count} color="#3b82f6" icon="🏷️" />
        <StateCard label="Active Warehouses" count={data.warehouse_count} color="#8b5cf6" icon="🏬" />
        <StateCard label="Low Stock" count={data.low_stock_count} color="#f59e0b" icon="⚠️" />
        <StateCard label="Out of Stock" count={data.out_of_stock_count} color="#ef4444" icon="🚫" />
      </div>

      <h3 style={{ fontSize: 16, fontWeight: 700, color: '#1a1a2e', marginBottom: 10 }}>Pending Actions</h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14, marginBottom: 20 }}>
        <StateCard label="Pending Approval Adjustments" count={pa.pending_approval_adjustments} color="#f59e0b" icon="✅" />
        <StateCard label="Shortage Reservations" count={pa.shortage_reservations} color="#ef4444" icon="🔻" />
        <StateCard label="Pending Pickings" count={pa.pending_pickings} color="#3b82f6" icon="🧺" />
        <StateCard label="Returns Pending Inspection" count={pa.pending_inspection_returns} color="#8b5cf6" icon="↩️" />
        <StateCard label="Counts In Progress" count={pa.in_progress_counts} color="#10b981" icon="🧮" />
        <StateCard label="Transfers In Transit" count={pa.transfers_in_transit} color="#f97316" icon="🚚" />
      </div>

      <h3 style={{ fontSize: 16, fontWeight: 700, color: '#1a1a2e', marginBottom: 10 }}>Recent Movements</h3>
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr>{['Movement #', 'Product', 'Warehouse', 'Type', 'Qty', 'Date'].map(h => (
                <th key={h} style={{ textAlign: 'left', padding: '10px 12px', borderBottom: '2px solid #e5e7eb', fontSize: 12, fontWeight: 600, color: '#6b7280' }}>{h}</th>
              ))}</tr>
            </thead>
            <tbody>
              {(data.recent_movements || []).length === 0 && (
                <tr><td colSpan={6} style={{ padding: 12, textAlign: 'center', color: '#9ca3af' }}>No movements yet</td></tr>
              )}
              {(data.recent_movements || []).map(m => (
                <tr key={m.id}>
                  <td style={{ padding: '10px 12px', borderBottom: '1px solid #f3f4f6' }}>{m.movement_number}</td>
                  <td style={{ padding: '10px 12px', borderBottom: '1px solid #f3f4f6' }}>{m.product?.name}</td>
                  <td style={{ padding: '10px 12px', borderBottom: '1px solid #f3f4f6' }}>{m.warehouse?.name}</td>
                  <td style={{ padding: '10px 12px', borderBottom: '1px solid #f3f4f6' }}>{(m.movement_type || '').replace(/_/g, ' ')}</td>
                  <td style={{ padding: '10px 12px', borderBottom: '1px solid #f3f4f6' }}>{m.direction === 'out' ? '-' : '+'}{m.quantity}</td>
                  <td style={{ padding: '10px 12px', borderBottom: '1px solid #f3f4f6' }}>{m.created_at ? new Date(m.created_at).toLocaleString() : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
